import { GET_ALL_BOOKINGS, GET_ALL_BOOKINGS_FAIL, GET_ALL_BOOKINGS_SUCCESS, GET_BOOKING_BY_BOOKING_NO, GET_BOOKING_BY_BOOKING_NO_FAIL, GET_BOOKING_BY_BOOKING_NO_SUCCESS, TRACK_BOOKING, TRACK_BOOKING_FAIL, TRACK_BOOKING_SUCCESS, GET_BOOKING_BY_CONTAINER_WISE, GET_BOOKING_BY_CONTAINER_WISE_FAIL, GET_BOOKING_BY_CONTAINER_WISE_SUCCESS, GET_BOOKING_BY_BOOKING_PROGRESS, GET_BOOKING_BY_BOOKING_NO_PROGRESS } from "./actionTypes"

//Get Bookings
export const getAllBooking = () => ({
  type: GET_ALL_BOOKINGS,
})
export const getAllBookingSuccess = booking => ({
  type: GET_ALL_BOOKINGS_SUCCESS,
  payload: booking,
})
export const getAllBookingFail = error => ({
  type: GET_ALL_BOOKINGS_FAIL,
  payload: error,
})

//Get Booking track
export const trackBooking = (containerNumber) => ({
  type: TRACK_BOOKING,
  payload: containerNumber,
})
export const trackBookingSuccess = track => ({
  type: TRACK_BOOKING_SUCCESS,
  payload: track,
})
export const trackBookingFail = error => ({
  type: TRACK_BOOKING_FAIL,
  payload: error,
})

//Get Booking track by booking no
export const getByBookingNo = (trackId) => ({
  type: GET_BOOKING_BY_BOOKING_NO,
  payload: trackId
})
export const getByBookingNoProgress = () => ({
  type: GET_BOOKING_BY_BOOKING_NO_PROGRESS,
  payload: {},
})
export const getByBookingNoSuccess = data => ({
  type: GET_BOOKING_BY_BOOKING_NO_SUCCESS,
  payload: data,
})
export const getByBookingNoFail = error => ({
  type: GET_BOOKING_BY_BOOKING_NO_FAIL,
  payload: error,
})

//Get Booking track by container wise
export const getBookingBYContainerWise = (trackId, containerId) => ({
  type: GET_BOOKING_BY_CONTAINER_WISE,
  payload: { trackId, containerId }
})
export const getBookingBYContainerWiseSuccess = data => ({
  type: GET_BOOKING_BY_CONTAINER_WISE_SUCCESS,
  payload: data,
})
export const getBookingBYContainerWiseFail = error => ({
  type: GET_BOOKING_BY_CONTAINER_WISE_FAIL,
  payload: error,
})